// extracted by mini-css-extract-plugin
export default {"permissionContainer":"WkjEZqasU11GjGwk9uZN"};